export { describeUnexpectedError }

import { SUPPORT_EMAIL } from '../utils/messages.ts'

// Map an error thrown from a Telefunc call or `fetch` into a one-line user-facing message
// that says what failed and what to do next. Never echoes server jargon (stack traces, SQL
// errors, raw response bodies) into the UI — the caller logs those via console.error.
//
// Only the network-vs-everything-else split is reliable, and the transport-failure shape
// depends on who threw: a raw `fetch` throws a `TypeError` (DNS, offline, TLS), but Telefunc
// catches that internally and re-throws `Error` tagged `{ isConnectionError: true }` (see its
// client's makeHttpRequest) — NOT a `TypeError`. Our callers here are all Telefunc calls, so
// matching only `TypeError` would miss every real network failure and wrongly show the generic
// "email support" line for a plain offline blip. Check both shapes. Any finer classification
// (5xx vs 4xx, etc.) would require pattern-matching telefunc's error-message format — which
// changes across versions — so we collapse the rest to one generic "retry / email support" line.
function describeUnexpectedError(err: unknown): string {
  if (err instanceof TypeError || (err as { isConnectionError?: boolean } | null)?.isConnectionError) {
    return "Couldn't reach the server. Check your internet connection and try again."
  }
  return `Something unexpected happened. Please try again, or email ${SUPPORT_EMAIL} if it keeps happening.`
}
